"use client";

import { useEffect, useRef } from "react";
import isEqual from "lodash.isequal";

const useDeepCompareEffect = (
  callback: React.EffectCallback,
  dependencies: unknown[]
) => {
  const previousDepsRef = useRef<unknown[] | undefined>(undefined);

  if (!isEqual(previousDepsRef.current, dependencies)) {
    previousDepsRef.current = dependencies;
  }

  useEffect(callback, [previousDepsRef.current]);
};

export default useDeepCompareEffect;
